import { Box } from "@caspeco/casper-ui-library.components.box";
import { Text } from "@caspeco/casper-ui-library.components.text";
import {
	ThemeBorderVariable,
	ThemeColorVariable,
	ThemeFontVariable,
	ThemeIconSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { CampaignDiscount } from "types/campaign";
import { Icon, Icons } from "@caspeco/casper-ui-library.components.icon";
import Price, { IPrice } from "components/price/Price";

interface ICartRowDiscount {
	discount: CampaignDiscount;
	borderBottom: boolean;
}

export default function CartRowDiscount({
	discount,
	showCurrency = true,
	borderBottom,
}: ICartRowDiscount & Pick<IPrice, "showCurrency">) {
	return (
		<Box
			as="article"
			py={ThemeSpaceVariable.Medium}
			borderBottom={borderBottom ? ThemeBorderVariable.XSmall : undefined}
			borderColor={ThemeColorVariable.OnSurfaceBorder}
		>
			<Box display="flex" alignContent="center" gap={ThemeSpaceVariable.Small}>
				<Icon
					size={ThemeIconSizeVariable.XLarge}
					color={ThemeColorVariable.OnSurface}
					icon={Icons.Discount}
				/>
				<Box display="flex" justifyContent="space-between" w="100%">
					<Text fontWeight="medium" fontFamily={ThemeFontVariable.SubHeader}>
						{discount.name}
					</Text>
					<Box display="flex" alignContent="center">
						<Price
							prepend="-"
							fontWeight="medium"
							inHousePrice={discount.discountAmount}
							showCurrency={showCurrency}
							fontFamily={ThemeFontVariable.SubHeader}
						/>
					</Box>
				</Box>
			</Box>
			{discount.code && <Text color={ThemeColorVariable.OnSurfaceSubdued}>{discount.code}</Text>}
		</Box>
	);
}
